// Schoorsteenveger Business Logic Constants

// Employee mapping by project_id
export const EMPLOYEES = {
  '453939612369290327': {
    id: '453939612369290327',
    name: 'Remco Zijlstra',
    color: '#0652dd' // blauw
  },
  '466362810120537940': {
    id: '466362810120537940',
    name: 'Fokke Veldstra',
    color: '#1eac68' // groen
  },
  '495888939377231540': {
    id: '495888939377231540',
    name: 'Niels van Vliet',
    color: '#f59e0b' // geel
  }
};

// Services mapping by ledger ID (from services_breakdown JSONB)
export const SERVICES = {
  'Schoorsteenvegen': {
    id: '448959125114586432',
    name: 'Schoorsteenvegen',
    emoji: '🏭',
    color: '#0d86f7' // Primary blue
  },
  'Camera inspectie': {
    id: '448959139853370688',
    name: 'Camera inspectie',
    emoji: '📹',
    color: '#93c5fd' // Light blue
  },
  'Vogelnest': {
    id: '448959162896876918',
    name: 'Vogelnest',
    emoji: '🐦',
    color: '#a5a5a5' // Light gray
  },
  'Mechanische Ventilatie': {
    id: '453848742796199755',
    name: 'Mechanische Ventilatie',
    emoji: '💨',
    color: '#bfdbfe' // Very light blue
  },
  'Renovatie': {
    id: '460907838909187246',
    name: 'Renovatie',
    emoji: '🔨',
    color: '#d1d5db' // Light gray
  }
};

// Authentication is verplaatst naar de backend (POST /api/login type=schoorsteenveger).
// Het wachtwoord wordt niet meer client-side bewaard of vergeleken.

// Invoice status mapping
export const getStatusInfo = (status) => {
  switch (status) {
    case 'paid':
      return { label: 'Betaald', color: 'green', emoji: '✅' };
    case 'sent':
      return { label: 'Verzonden', color: 'yellow', emoji: '📤' };
    case 'draft':
      return { label: 'Concept', color: 'gray', emoji: '📝' };
    default:
      return { label: 'Onbekend', color: 'gray', emoji: '❓' };
  }
};
